<template>
  <div>
    <div v-if="loading || bookings.length < 1">
      <v-row align="center" justify="center">
        <v-col>
          <Loading></Loading>
        </v-col>
      </v-row>
    </div>
    <div v-if="!loading && bookings.length > 0">
      <v-container>
        <v-row justify="end" v-if="showBadge">
          <v-col align="end" class="primary--text">
            <v-badge
              :content="text.length"
              color="primary"
              overlap
            >
            <v-icon large class="main--text" @click="show = !show">
              mdi-email
            </v-icon>
            </v-badge>
          </v-col>
        </v-row>
        <v-row justify="end" v-if="show" no-gutters>
          <v-col md="4" :align="$vuetify.breakpoint.smAndDown ? 'center' : 'end'">
            <v-card
              :height="text.length == 1 ? '70' : '150'"
              class="overflow-auto main mb-2"
              style="z-index: 1; position: fixed;"
              elevation="10"
              >
              <v-card-text>
                <v-row no-gutters>
                  <v-col align="start" no-gutters>
                    <v-alert
                      :key="i"
                      v-for="(note, i) in text"
                      border="left"
                      close-text="Close Alert"
                      color="primary"
                      colored-border
                      elevation="0"
                      prominent
                      rounded
                      dense
                      dark
                      transition="scale-transition"
                    >
                    {{note}}
                  </v-alert>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col md="8">
            <BookingCard
                class="mb-10"
                v-for="(booking, i) of bookings"
                :key="i"
                :booking="booking"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import BookingCard from '@/components/bookings/client/BookingCard';
import Loading from '@/components/Loading';

export default {
  name: 'ClientBookings',
  components: {
    Loading,
    BookingCard
  },
  data(){
    return{
      show: false,
      showBadge: true
    }
  },
  computed: {
    bookingError() {
      return this.$store.getters.getBookingError;
    },
    QuoteBookings(){
      return this.$store.getters.getQuoteBookings;
    },
    bookings() {
      return this.$store.getters.getBookings;
    },
    text(){
      return this.$store.getters.getText;
    },
    loading() {
      return this.$store.getters.getLoading;
    }
  },
  watch: {
    bookings(bookings) {
      if (bookings.length == 0) {
        this.$router.push('/dashboard/create');
      }
    },
    QuoteBookings(bookings){
      if(bookings.length > 0){
        alert('Choose your date & complete your booking.');
        this.$router.push('/dashboard/quotes');
      }
    },
    bookingError(error) {
      if (error) {
        console.log(error.message);
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>